import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import {CalendarDialog} from '../../common/MaterialDesignComponents';
import DateRangePicker from "../../common/datepicker/DateRangePicker";
import dayjs from 'dayjs';
import RoomSearchFormComponent from "./RoomSearchFormComponent";
import './RoomSearchFormComponent.css'
import RoomSearchCriteria from "../../../states/RoomSearchCriteria";
import RoomSearchFormState from "../../../states/RoomSearchFormState";

interface Attrs { 
    messageProvider: MessageProvider;
    searchCriteria?: RoomSearchCriteria;
    onSearch: (searchCriteria:RoomSearchCriteria) => void;
}

function RoomSearchFormCard(): m.Component<Attrs> {
    let roomSearchFormState:RoomSearchFormState = new RoomSearchFormState();
    let isShowingDateSelectionDialog = false;
    let startYear = dayjs().year();
    let startMonth = dayjs().month() + 1;

    return {
        oninit(vnode) {
            if(vnode.attrs.searchCriteria) {
                let searchCriteria = vnode.attrs.searchCriteria;
                roomSearchFormState.checkInDate = searchCriteria.getCheckInDate();
                roomSearchFormState.checkOutDate = searchCriteria.getCheckOutDate();
                roomSearchFormState.guestType = searchCriteria.getGuestType();
                roomSearchFormState.numberOfRooms = searchCriteria.getNumberOfRooms();
            }
        },
        onupdate(vnode) {
            if(isShowingDateSelectionDialog){
                document.body.style.overflow = "hidden";
            }else{
                document.body.style.overflow = "auto";
            }
        },

        view: function (vnode) {    
            const {messageProvider, onSearch} = vnode.attrs;    
    
            return [                
                    m("div.card.shadow.form-card rounded-25", 
                        m("div.card-body", 
                            m(RoomSearchFormComponent, {                
                                messageProvider : messageProvider,
                                roomSearchFormState : roomSearchFormState,
                                isOpeningDialog: isShowingDateSelectionDialog,
                                onSearchClick: function(){
                                    console.log("Search now", roomSearchFormState);
                                    onSearch(roomSearchFormState.toRoomSearchCriteria());
                                },
                                onDateRangePickerClick: function(){
                                    isShowingDateSelectionDialog = true;
                                },
                                onRoomCountChange: (numberOfRoom: number) => {
                                    roomSearchFormState.numberOfRooms = numberOfRoom;
                                },
                                onNationalityClick: function(nationality: string) {
                                    roomSearchFormState.guestType = (nationality == 'LOCAL')? 'LOCAL': 'FOREIGNER';
                                }
                            }) 
                        )
                    ),                   
                    

                    m(CalendarDialog, {
                        title: "Select Date",
                        isOnDesktop: true,
                        isOpen: isShowingDateSelectionDialog,
                        onClose : () => {
                            isShowingDateSelectionDialog = false;
                        },
                        actionItems : [
                            {
                                label: "Close",
                                onclick: () => {
                                    isShowingDateSelectionDialog = false;
                                }
                            }
                        ]
                    }, [
                        m(DateRangePicker, {
                            isOnDesktop: true,
                            startYear: startYear,
                            startMonth: startMonth,
                            selectedDateRange: {
                                startDate: roomSearchFormState.checkInDate,
                                endDate: roomSearchFormState.checkOutDate
                            },
                            startLabel: messageProvider.get("checkin_date"),
                            endLabel: messageProvider.get("checkout_date"),
                            applyButtonLabel: messageProvider.get("apply_dates"),
                            minDate: dayjs().format("YYYY-MM-DD"),
                            maxRange: 13,
                            onDateRangeSelected: (startDate, endDate) => {
                                isShowingDateSelectionDialog = false;    
                                roomSearchFormState.checkInDate = startDate;
                                roomSearchFormState.checkOutDate = endDate;                     
                            }
                        })
                    ])
                    
                ]
        }
    }
}

export default RoomSearchFormCard;

